<template>
    <div class="min-h-screen bg-gray-50 flex flex-col">
      <!-- 导航栏 -->
      <NavBar />
      
      <!-- 登录/注册区域 -->
      <div class="flex-grow flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div class="max-w-md w-full space-y-8 bg-white p-8 rounded-lg shadow-md">
          <!-- 标题 -->
          <div class="text-center">
            <h2 class="text-3xl font-bold text-gray-900">
              {{ mode === 'login' ? '欢迎登录' : '找回密码' }}
            </h2>
            <p class="mt-2 text-sm text-gray-600">
              <span v-if="mode !== 'login'">
                已有账号？
                <a href="javascript:;" class="font-medium text-[#76B900] hover:text-[#5a8f00]" @click="mode = 'login'">返回登录</a>
              </span>
            </p>
          </div>
  
          <!-- 登录方式切换 -->
          <div v-if="mode === 'login'" class="flex justify-center mb-4 space-x-4">
            <button
              :class="['px-3 py-1 rounded', loginTab === 'password' ? 'bg-[#76B900] text-white' : 'bg-gray-100 text-gray-700']"
              @click="loginTab = 'password'"
            >密码登录</button>
            <button
              :class="['px-3 py-1 rounded', loginTab === 'sms' ? 'bg-[#76B900] text-white' : 'bg-gray-100 text-gray-700']"
              @click="loginTab = 'sms'"
            >短信验证码登录</button>
          </div>
  
          <!-- 登录表单 -->
          <div v-if="mode === 'login'">
            <!-- 密码登录表单 -->
            <form v-if="loginTab === 'password'" class="mt-8 space-y-6" @submit.prevent="handleLogin">
              <div class="rounded-md shadow-sm space-y-4">
                <!-- 手机号/用户名输入框 -->
                <div>
                  <label for="account" class="block text-sm font-medium text-gray-700">手机号/用户名</label>
                  <div class="mt-1">
                    <input
                      id="account"
                      v-model="loginForm.account"
                      name="account"
                      type="text"
                      required
                      class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#76B900] focus:border-[#76B900]"
                      placeholder="请输入手机号或用户名"
                    >
                  </div>
                </div>
                <!-- 密码输入框 -->
                <div>
                  <label for="password" class="block text-sm font-medium text-gray-700">密码</label>
                  <div class="mt-1 relative">
                    <input
                      id="password"
                      v-model="loginForm.password"
                      name="password"
                      :type="showPassword ? 'text' : 'password'"
                      required
                      class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#76B900] focus:border-[#76B900]"
                      placeholder="请输入密码"
                      @input="trimPassword"
                    >
                    <button
                      type="button"
                      class="absolute inset-y-0 right-0 pr-3 flex items-center"
                      @click="showPassword = !showPassword"
                    >
                      <i :class="['fas', showPassword ? 'fa-eye-slash' : 'fa-eye', 'text-gray-400']"></i>
                    </button>
                  </div>
                </div>
              </div>
              <!-- 记住我和忘记密码 -->
              <div class="flex items-center justify-between">
                <div class="flex items-center">
                  <input
                    id="remember-me"
                    v-model="loginForm.rememberMe"
                    name="remember-me"
                    type="checkbox"
                    class="h-4 w-4 text-[#76B900] focus:ring-[#76B900] border-gray-300 rounded"
                  >
                  <label for="remember-me" class="ml-2 block text-sm text-gray-900">
                    记住我
                  </label>
                </div>
                <div class="text-sm">
                  <a href="javascript:;" class="font-medium text-[#76B900] hover:text-[#5a8f00]" @click="mode = 'forget'">
                    忘记密码？
                  </a>
                </div>
              </div>
              <!-- 登录按钮 -->
              <div>
                <button
                  type="submit"
                  class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#76B900] hover:bg-[#5a8f00] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#76B900]"
                  :disabled="loading"
                >
                  <i v-if="loading" class="fas fa-spinner fa-spin mr-2"></i>
                  {{ loading ? '登录中...' : '登录' }}
                </button>
              </div>
            </form>
            <!-- 短信验证码登录表单 -->
            <form v-if="loginTab === 'sms'" class="mt-8 space-y-6" @submit.prevent="handleSmsLogin">
              <div class="rounded-md shadow-sm space-y-4">
                <div>
                  <label class="block text-sm font-medium text-gray-700">手机号</label>
                  <input
                    v-model="smsLoginForm.phone"
                    type="tel"
                    required
                    class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#76B900] focus:border-[#76B900]"
                    placeholder="请输入手机号"
                  >
                </div>
                <div class="mb-6 flex items-center gap-2">
                  <div class="flex-1">
                    <label class="block text-gray-700 font-medium mb-1">短信验证码</label>
                    <input v-model="smsLoginForm.sms_code" type="text" maxlength="6" placeholder="请输入验证码"
                           class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#76B900]" />
                  </div>
                  <button type="button" @click="handleGetLoginSmsCode" :disabled="smsLoginBtnDisabled"
                          class="h-10 mt-6 px-3 bg-[#76B900] hover:bg-[#5a8f00] text-white rounded-lg text-sm whitespace-nowrap">
                    {{ smsLoginBtnText }}
                  </button>
                </div>
              </div>
              <div>
                <button
                  type="submit"
                  class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#76B900] hover:bg-[#5a8f00] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#76B900]"
                  :disabled="smsLoginLoading"
                >
                  <i v-if="smsLoginLoading" class="fas fa-spinner fa-spin mr-2"></i>
                  {{ smsLoginLoading ? '登录中...' : '登录' }}
                </button>
              </div>
            </form>
          </div>
          <!-- 忘记密码表单 -->
          <div v-else-if="mode === 'forget'">
            <form class="mt-8 space-y-6" @submit.prevent="handleForgetPassword">
              <div class="rounded-md shadow-sm space-y-4">
                <!-- 手机号输入框 -->
                <div>
                  <label class="block text-sm font-medium text-gray-700">手机号</label>
                  <div class="mt-1">
                    <input
                      v-model="forgetForm.phone"
                      type="tel"
                      maxlength="11"
                      required
                      class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#76B900] focus:border-[#76B900]"
                      placeholder="请输入手机号"
                    >
                  </div>
                </div>
                <!-- 图形验证码 -->
                <div class="flex items-center mt-2">
                  <input v-model="forgetForm.captcha_code" placeholder="请输入图形验证码" class="flex-1 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#76B900] focus:border-[#76B900]" />
                  <img :src="captchaImg" @click="getForgetCaptcha" class="ml-2 h-10 w-24 object-contain cursor-pointer" :title="'点击刷新验证码'" />
                </div>
                <!-- 短信验证码输入框 -->
                <div>
                  <label class="block text-sm font-medium text-gray-700">验证码</label>
                  <div class="mt-1 flex space-x-2">
                    <input
                      v-model="forgetForm.sms_code"
                      type="text"
                      maxlength="6"
                      required
                      class="flex-1 max-w-[140px] px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#76B900] focus:border-[#76B900]"
                      placeholder="请输入验证码"
                    >
                    <button
                      type="button"
                      class="flex-shrink-0 min-w-[110px] px-3 py-2 rounded-md bg-[#76B900] hover:bg-[#5a8f00] text-white text-sm font-medium focus:outline-none focus:ring-2 focus:ring-[#76B900]"
                      :disabled="smsBtnDisabled"
                      @click="handleForgetSendSms"
                    >{{ smsBtnText }}</button>
                  </div>
                </div>
                <!-- 新密码输入框 -->
                <div>
                  <label class="block text-sm font-medium text-gray-700">新密码</label>
                  <div class="mt-1">
                    <input
                      v-model="forgetForm.password"
                      type="password"
                      required
                      class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#76B900] focus:border-[#76B900]"
                      placeholder="请输入新密码"
                    >
                  </div>
                </div>
              </div>
              <div class="flex justify-between mt-6 space-x-4">
                <button
                  type="submit"
                  class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#76B900] hover:bg-[#5a8f00] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#76B900]"
                  :disabled="forgetLoading"
                >
                  <i v-if="forgetLoading" class="fas fa-spinner fa-spin mr-2"></i>
                  重置密码
                </button>
                <button
                  type="button"
                  class="w-full flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-[#76B900] bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#76B900]"
                  @click="mode = 'login'"
                >
                  返回登录
                </button>
              </div>
            </form>
          </div>
        </div>
        <!-- 图形验证码弹窗 -->
        <div v-if="showCaptchaDialog" class="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-[9999]">
            <div class="bg-white rounded-lg p-8 w-80 flex flex-col items-center">
              <h3 class="text-lg font-bold mb-4">请输入图形验证码</h3>
              <img :src="captchaImg" @click="getCaptcha" class="h-12 w-32 object-contain cursor-pointer mb-2" :title="'点击刷新验证码'" />
              <input v-model="captchaInputDialog" maxlength="6" placeholder="请输入验证码" class="w-full px-3 py-2 border border-gray-300 rounded mb-4" />
              <div class="flex w-full gap-2">
                <button @click="showCaptchaDialog=false" class="flex-1 bg-gray-200 text-gray-700 rounded px-4 py-2">取消</button>
                <button @click="confirmCaptcha" class="flex-1 bg-[#76B900] text-white rounded px-4 py-2">确定</button>
              </div>
            </div>
          </div>
      </div>
    </div>
  </template>
  
  <script>
  import NavBar from '@/components/common/NavBar.vue'
  import { login, forgetPassword, sendSms, getCaptcha, loginBySms } from '@/api/auth'
  import { Message } from 'element-ui'
  
  export default {
    name: 'UserLogin',
    components: {
      NavBar,
    },
    data() {
      return {
        mode: 'login',
        loginTab: 'password',
        // 登录表单数据
        loginForm: {
          account: '',
          password: '',
          rememberMe: false
        },
        smsLoginForm: {
          phone: '',
          sms_code: '',
          captcha_code: ''
        },
        smsLoginLoading: false,
        smsLoginBtnText: '获取验证码',
        smsLoginBtnDisabled: false,
        smsLoginTimer: null,
        showPassword: false,
        loading: false,
        // 忘记密码相关
        forgetForm: {
          phone: '',
          sms_code: '',
          password: '',
          captcha_code: ''
        },
        forgetLoading: false,
        smsBtnText: '获取验证码',
        smsBtnDisabled: false,
        smsTimer: null,
        captchaId: '',
        captchaImg: '',
        showCaptchaDialog: false,
        captchaInputDialog: '',
        captchaInput: '',
      }
    },
    methods: {
      trimPassword() {
        this.loginForm.password = this.loginForm.password.trim();
      },
      async handleLogin() {
        if (!this.loginForm.account || !this.loginForm.password) {
          Message.warning({ message: '请填写手机号/用户名和密码', showClose: true })
          return
        }
        this.loading = true
        try {
          const response = await login({
            username: this.loginForm.account,
            password: this.loginForm.password
          })
          // 保存登录状态和用户信息
          localStorage.setItem('authToken', response.access_token)
          localStorage.setItem('isAuthenticated', 'true')
          localStorage.setItem('phone', response.phone)
          localStorage.setItem('username', response.username)
          if (response.avatar) {
            localStorage.setItem('avatar', response.avatar)
          } else {
            localStorage.removeItem('avatar')
          }
          localStorage.setItem('role', response.role)
          // 如果选择了记住我
          if (this.loginForm.rememberMe) {
            localStorage.setItem('rememberedAccount', this.loginForm.account)
          } else {
            localStorage.removeItem('rememberedAccount')
          }
          this.$store.dispatch('cart/fetchCart');
          this.$store.dispatch('user/fetchUserInfo');
          // 登录成功后获取默认店铺id
          this.$store.dispatch('user/fetchDefaultStore');
          // 触发全局登录事件
          if (window.vueInstance) {
            window.vueInstance.$root.$emit('auth-change', {
              isAuthenticated: true,
              phone: response.phone,
              username: response.username,
              role: response.role,
              avatar: response.avatar || ''
            })
          }
          Message.success({ message: '登录成功', showClose: true })
          const redirect = this.$route.query.redirect || '/'
          this.$router.replace(redirect)
        } catch (error) {
          console.error('登录过程中发生错误:', error)
        } finally {
          this.loading = false
        }
      },
      async getCaptcha() {
        try {
          const res = await getCaptcha();
          this.captchaId = res.captcha_id;
          this.captchaImg = res.img_b64;
        } catch (e) {
          Message.error({ message: '获取验证码失败', showClose: true });
        }
      },
      handleGetLoginSmsCode() {
        // 每次点击都弹出图形验证码弹窗
        this.showCaptchaDialog = true;
      },
      async confirmCaptcha() {
        if (!this.captchaInputDialog || this.captchaInputDialog.length < 4) {
          this.$message && this.$message.warning({ message: '请输入图形验证码', showClose: true });
          return;
        }
        this.captchaInput = this.captchaInputDialog;
        try {
          await this.handleSendLoginSms();
          this.showCaptchaDialog = false;
        } catch (e) {
          // 如果是图形验证码相关错误，刷新验证码并保持弹窗，不提示错误
          const detail = e?.response?.data?.detail || '';
          if (detail.includes('图形验证码')) {
            this.getCaptcha();
            this.captchaInputDialog = '';
            // 不提示错误，用户重新输入
          } else {
            this.$message && this.$message.error({ message: '验证码发送失败', showClose: true });
            this.showCaptchaDialog = false;
          }
        }
      },
      async handleSendLoginSms() {
        const phoneRegex = /^1[3-9]\d{9}$/;
        if (!phoneRegex.test(this.smsLoginForm.phone)) {
          this.$message && this.$message.warning({ message: '请输入有效的手机号码', showClose: true });
          return;
        }
        if (!this.captchaInput || this.captchaInput.length < 4) {
          this.$message && this.$message.warning({ message: '请先输入图形验证码', showClose: true });
          this.showCaptchaDialog = true;
          return;
        }
        try {
          this.smsLoginBtnDisabled = true;
          await sendSms({
            phone_number: this.smsLoginForm.phone,
            captcha_id: this.captchaId,
            captcha_code: this.captchaInput,
            sms_type: 'login'
          });
          this.$message && this.$message.success({ message: '验证码已发送', showClose: true });
          this.startSmsLoginTimer();
        } catch (e) {
          this.smsLoginBtnDisabled = false;
          this.getCaptcha();
        }
      },
      startSmsLoginTimer() {
        let count = 60;
        this.smsLoginBtnText = `${count}s后重试`;
        this.smsLoginBtnDisabled = true;
        this.smsLoginTimer = setInterval(() => {
          count--;
          if (count <= 0) {
            clearInterval(this.smsLoginTimer);
            this.smsLoginBtnText = '获取验证码';
            this.smsLoginBtnDisabled = false;
          } else {
            this.smsLoginBtnText = `${count}s后重试`;
          }
        }, 1000);
      },
      async handleSmsLogin() {
        const phoneRegex = /^1[3-9]\d{9}$/;
        if (!phoneRegex.test(this.smsLoginForm.phone)) {
          Message.warning({ message: '请输入有效的手机号码', showClose: true });
          return;
        }
        if (!this.smsLoginForm.sms_code || this.smsLoginForm.sms_code.length < 4) {
          Message.warning({ message: '请输入有效的验证码', showClose: true });
          return;
        }
        this.smsLoginLoading = true;
        try {
          const response = await loginBySms({
            phone: this.smsLoginForm.phone,
            sms_code: this.smsLoginForm.sms_code
          });
          localStorage.setItem('authToken', response.access_token)
          localStorage.setItem('isAuthenticated', 'true')
          localStorage.setItem('phone', response.phone)
          localStorage.setItem('username', response.username)
          localStorage.setItem('role', response.role)
          if (response.avatar) {
            localStorage.setItem('avatar', response.avatar)
          } else {
            localStorage.removeItem('avatar')
          }
          this.$store.dispatch('cart/fetchCart');
          this.$store.dispatch('user/fetchUserInfo');
          if (window.vueInstance) {
            window.vueInstance.$root.$emit('auth-change', { 
              isAuthenticated: true, 
              phone: response.phone,
              username: response.username,
              role: response.role,
              avatar: response.avatar || ''
            })
          }
          Message.success({ message: '登录成功', showClose: true })
          const redirect = this.$route.query.redirect || '/'
          this.$router.replace(redirect)
        } catch (e) {
          // 错误处理
        } finally {
          this.smsLoginLoading = false;
        }
      },
      async handleForgetPassword() {
        const { phone, sms_code, password, captcha_code } = this.forgetForm;
        if (!phone || !sms_code || !password || !captcha_code) {
          Message.warning({ message: '请填写完整信息', showClose: true });
          return;
        }
        this.forgetLoading = true;
        try {
          await forgetPassword({ phone, sms_code, password });
          Message.success({ message: '密码重置成功，请登录', showClose: true });
          this.mode = 'login';
          this.forgetForm = { phone: '', sms_code: '', password: '', captcha_code: '' };
          this.getForgetCaptcha();
        } catch (e) {
          if (e && e.response && e.response.data && e.response.data.detail) {
            Message.error({ message: e.response.data.detail, showClose: true });
          } else {
            Message.error({ message: '重置密码失败，请重试', showClose: true });
          }
        } finally {
          this.forgetLoading = false;
        }
      },
      async getForgetCaptcha() {
        try {
          const res = await getCaptcha();
          this.captchaId = res.captcha_id;
          this.captchaImg = res.img_b64;
        } catch (e) {
          Message.error({ message: '获取验证码失败', showClose: true });
        }
      },
      async handleForgetSendSms() {
        const phone = this.forgetForm.phone;
        const phoneRegex = /^1[3-9]\d{9}$/;
        if (!phoneRegex.test(phone)) {
          Message.warning({ message: '请输入有效的手机号码', showClose: true });
          return;
        }
        if (!this.forgetForm.captcha_code || this.forgetForm.captcha_code.length < 4) {
          Message.warning({ message: '请输入图形验证码', showClose: true });
          return;
        }
        try {
          await sendSms({
            phone_number: phone,
            captcha_id: this.captchaId,
            captcha_code: this.forgetForm.captcha_code,
            sms_type: 'forgetpwd'
          });
          Message.success({ message: '验证码已发送', showClose: true });
          this.smsBtnDisabled = true;
          let count = 60;
          this.smsBtnText = `${count}s`;
          this.smsTimer = setInterval(() => {
            count--;
            this.smsBtnText = `${count}s`;
            if (count <= 0) {
              clearInterval(this.smsTimer);
              this.smsBtnText = '获取验证码';
              this.smsBtnDisabled = false;
            }
          }, 1000);
          this.getForgetCaptcha();
        } catch (e) {
          Message.error({ message: '验证码发送失败', showClose: true });
          this.getForgetCaptcha();
        }
      },
    },
    created() {
      const rememberedAccount = localStorage.getItem('rememberedAccount')
      if (rememberedAccount) {
        this.loginForm.account = rememberedAccount
        this.loginForm.rememberMe = true
      }
    },
    mounted() {
      this.getCaptcha();
    },
    beforeDestroy() {
      if (this.smsLoginTimer) clearInterval(this.smsLoginTimer);
      if (this.smsTimer) clearInterval(this.smsTimer);
    },
    watch: {
      showCaptchaDialog(val) {
        if (val) {
          this.captchaInputDialog = '';
          this.getCaptcha();
        }
      },
    }
  }
  </script> 